"use client"

import { Pen } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `PenIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const PenIcon = component(Icon)({ as: Pen })
